export default __webpack_public_path__ + "assets/PNC-8ab25315966b5b8b900754e6d66b1a09.svg";